import styles from './About.module.scss'

export default function About() {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>À propos</h1>
      <p className={styles.text}>
        Cette application est construite avec React, Vite, TypeScript et
        Carbon Design System.
      </p>
    </div>
  )
}
